export enum OfferTypeEnum {
    None = 0,
    Internal = 1 << 0,
    Actiris = 1 << 1,
    Student = 1 << 2,
    Traineeship = 1 << 3,
    External = 1 << 4,
}

export const OfferTypeStringEnum = {
    [OfferTypeEnum.None]: 'None',
    [OfferTypeEnum.Internal]: 'Internal',
    [OfferTypeEnum.Actiris]: 'Actiris',
    [OfferTypeEnum.Student]: 'Student',
    [OfferTypeEnum.Traineeship]: 'Traineeship',
    [OfferTypeEnum.External]: 'External',
};
